import PropTypes from 'prop-types';

const defaultTitle =
  'Helt-Cool i Nim | Hundelydighed | Klikkertræning | Dyreadfærdskonsulent | Svanes Dyr ';
const defaultDescription = 'Svanes Dyr - Helt-Cool kursus for hunde i Nim, nær Horsens';
const defaultKeywords = `Hundehold Horsens, Hundetræning Horsens, hund trækker, hund gå pænt, hund hopper op, hund hopper gæster, hund gæster, hund hilse pænt,
  hund lydighed, lydighedshold, hundelydighed, lydighed, cool hund, helt cool hund, helt cool, helt-cool, hund rolig gåtur, hund gåtur,
  selvkontrol hund, impulskontrol hund, doggie zen, belønning hund`;

const MetaDogCool = ({
  title = defaultTitle,
  description = defaultDescription,
  keywords = defaultKeywords,
}) => (
  <>
    <title>{title}</title>
    <meta property="og:title" content={title} />
    <link rel="canonical" href="https://www.svanesdyr.dk/hundehold/coolhold" />
    <meta property="og:url" content="https://www.svanesdyr.dk/hundehold/coolhold" />

    <meta property="og:locale" content="da_DK" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://www.svanesdyr.dk/MetaDogCool.png" />
    <meta property="og:site_name" content="Svanes Dyr" />

    <meta name="keywords" content={keywords} />
    <meta name="description" content={description} />
    <meta property="og:description" content={description} />
  </>
);

MetaDogCool.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
};

export default MetaDogCool;
